/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/indent */
/* eslint-disable indent */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
/* eslint-disable arrow-parens */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/member-ordering */
import { ITask, Nullable } from './ITask';
import Task from './task';

export const TaskPriority = {
    LOW: -10000,         // 低优先级
    NORMAL: 0,    // 正常优先级
    HIGH: 10000,    // 高优先级
};

export default class TaskManager {
    // 保存所有要执行的任务
    taskMap: Map<string, ITask>;

    // 当前执行的任务
    currentTask: Nullable<ITask>;

    static instance: TaskManager;
    static getInstance(): TaskManager {
        if (!TaskManager.instance) {
            TaskManager.instance = new TaskManager();
        }
        return TaskManager.instance;
    }

    constructor() {
        this.taskMap = new Map<string, ITask>();
    }

    getWaitingTaskByPriority(): Nullable<ITask> {
        let waitingTask: Nullable<ITask> = null;
        this.taskMap.forEach((task) => {
            if (!task.isPaused && !task.isExecuting && !task.isCanceled) {
                if (!waitingTask || waitingTask.priority < task.priority) {
                    waitingTask = task;
                }
            }
        });
        return waitingTask;
    }

    autoExecuteTask() {
        // let keys = this.taskMap.keys();
        // console.log('000===task---------------------queue', keys);
        if (!this.currentTask) {
            // 寻找最高优先级的任务执行
            const task = this.getWaitingTaskByPriority();
            if (task) {
                // console.log('taskgroup--------------------------------------', task.constructor.name);
                this.currentTask = task;
                task.asyncStart();
            }
        }
    }

    handleTaskFinished = (task: ITask) => {
        if (!task.isPaused) {
            this.taskMap.delete(task.key);

            // if (!task.isCanceled) {
            //     console.log('000===task-finished', task.key);
            // } else {
            //     console.log('000===task-canceled', task.key);
            // }
        } else {
            // console.log('000===paused-task-', task.key);
        }

        if (task === this.currentTask) {
            this.currentTask = null;
            setTimeout(() => {
                this.autoExecuteTask();
            }, 0);
        }
    };
    static async addTask(task: ITask) {
        if (!task) return;
        const _this = TaskManager.getInstance();
        const existTask = _this.taskMap.get(task.key);
        if (!existTask) {
            _this.taskMap.set(task.key, task);
            task.promise.then(() => {
                _this.handleTaskFinished(task);
            });
            _this.autoExecuteTask();
            await task.promise;
        } else {
            existTask.priority = task.priority;
            await existTask.promise;
        }
    }

    static async addTaskWithBlock(key: string, priority: number, block: Nullable<() => Promise<any> | void>) {
        if (!key) return;
        const _this = TaskManager.getInstance();
        let task = _this.taskMap.get(key);
        if (task) {
            task.priority = priority;
        } else {
            task = new Task(key, priority, block);
            TaskManager.addTask(task);
        }
        await task.promise;
    }

    static cancelTaskByKey(key: string) {
        if (!key) return;
        const _this = TaskManager.getInstance();
        const task = _this.taskMap.get(key);
        if (task) {
            task.cancel();
        }
    }

    static getAllTasksContainsKey(key: string): ITask[] {
        if (!key) return [];
        const _this = TaskManager.getInstance();
        const tasks: ITask[] = [];
        _this.taskMap.forEach((task, taskKey) => {
            if (taskKey.includes(key)) {
                tasks.push(task);
            }
        });
        return tasks;
    }

    static cancelAllTasks() {
        const _this = TaskManager.getInstance();
        _this.taskMap.forEach(task => {
            task.cancel();
        });
    }

    static getTaskWithKey(key: string) {
        if (!key) return null;
        const _this = TaskManager.getInstance();
        const task = _this.taskMap.get(key);
        return task;
    }

    static resumeTaskWithKey(key: string) {
        const task = TaskManager.getTaskWithKey(key);
        if (task) {
            task.resume();
        }

        const _this = TaskManager.getInstance();
        _this.autoExecuteTask();
    }

    static pauseTaskWithKey(key: string) {
        const task = TaskManager.getTaskWithKey(key);
        if (task) {
            task.pause();
        }
    }

    public static pauseTaskByKey(key: string) {
        if (!key) return;
        // eslint-disable-next-line no-underscore-dangle
        const _this = TaskManager.getInstance();
        const task = _this.taskMap.get(key);
        if (task) {
            if (task === _this.currentTask) { // pause不会执行finished，所以这里要把currentTask置空
                _this.currentTask = null;
            }
            task.pause();
            _this.autoExecuteTask();
        }
    }
}
